import {
  addFavoriteContactAction,
  removeFavoriteContactAction,
} from 'actions/contactList/toggleFavoriteContactAction'
import { fetchProfileOptionalAction } from 'actions/profile/fetchProfileOptionalAction'
import { AsyncThunkAction } from 'actions/types'
import { UserOptionalProfileResult } from 'api/profile/fetchUserProfileApi'
import { ProfileStatus } from 'api/profile/profile.functions'

export const toggleFavoriteAction =
  (profileId: number): AsyncThunkAction =>
  async (dispatch) => {
    //
    const { result } = (await dispatch(
      fetchProfileOptionalAction(profileId, [ProfileStatus.Favourites])
    )) as unknown as { result: UserOptionalProfileResult }

    const json = result as UserOptionalProfileResult

    if (!json.statuses.inMyFavorites.isOn) {
      dispatch(addFavoriteContactAction(profileId))
    } else {
      dispatch(removeFavoriteContactAction(profileId))
    }
  }
